<template>
  <section v-if="status || blogs.post.length" class="articles weblog-home">
    <div class="container">
      <BigTitle class="mb-2 mb-sm-4" title="مجله زیبایی آنجل بار" />

      <!-- <HeaderSection custom-style="background-image:linear-gradient(to right, #e6e6e6, #606060, #e6e6e6)" :textBtn="'مطالب بیشتر'" :status="status" :text="'پست ها'" :route="'/weblog-list'" /> -->
      <b-row v-if="status">
        <b-col>
          <b-skeleton-img></b-skeleton-img> <br />
          <b-skeleton></b-skeleton>
        </b-col>
        <b-col>
          <b-skeleton-img></b-skeleton-img><br />
          <b-skeleton></b-skeleton>
        </b-col>
        <b-col>
          <b-skeleton-img></b-skeleton-img><br />
          <b-skeleton></b-skeleton>
        </b-col>
        <b-col>
          <b-skeleton-img></b-skeleton-img><br />
          <b-skeleton></b-skeleton>
        </b-col>
      </b-row>
      <div id="blogArticleContent" v-else class=" pt-4">
        <!-- دریافت اطلاعات از آبجکت هوم و وارد شدن به آبجکت پست -->
        <div v-if="blogs != null">
          <div class="swiper-container ">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide "
                v-for="(blog, index) in blogs.post"
                :key="'Blog' + index"
              >
                <postCard :blog="blog" />
              </div>
            </div>
          </div>

          <!-- <article
              v-for="(blog, index) in blogs.post"
              :key="'Blog' + index"
              class=""
          >
            <router-link
                :to="{
                 name: 'blogDetail',
                          params: { id: blog.id },
                          query:{'slug':blog.slug}
          }"
            >
              <div class="article-img">
                <img loading="lazy" v-if="blog.image" :src="blog.image.url" :alt="blog.title" />
                <img loading="lazy" v-else src="../../../assets/images/blog.jpg" alt="blog">
                <div class="category d-none d-sm-block"><span class="ml-05">دسته‌بندی:</span> <span class="font-weight-bold">{{ blog.category.name }}</span></div>
                <div
                    class="
                article-img-hover
                d-flexs
                show-by-hover
                align-items-end
                justify-content-between
                px-4
              "
                >

                </div>
              </div>
              <div class="text-right article-title text-color-666 p-1">
                <h6
                    class="d-inline-block fontsize-small weight-bold text-color-444 mt-3"
                >
                  <svg
                      class="mt-n1"
                      width="15"
                      height="15"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M7.36922 10.869C7.42572 10.811 7.63906 10.563 7.8378 10.359C9.00292 9.076 12.0424 6.976 13.6332 6.335C13.8748 6.232 14.4856 6.014 14.812 6C15.1247 6 15.4228 6.072 15.7073 6.218C16.0619 6.422 16.3463 6.743 16.5022 7.122C16.6025 7.385 16.7584 8.172 16.7584 8.186C16.9143 9.047 17 10.446 17 11.992C17 13.465 16.9143 14.807 16.7867 15.681C16.772 15.695 16.6162 16.673 16.4457 17.008C16.133 17.62 15.5222 18 14.8685 18H14.812C14.3863 17.985 13.491 17.605 13.491 17.591C11.9859 16.949 9.01656 14.952 7.82319 13.625C7.82319 13.625 7.48709 13.284 7.34096 13.071C7.11301 12.765 7 12.386 7 12.007C7 11.584 7.12762 11.19 7.36922 10.869Z"
                        fill="#444"
                    />
                  </svg>
                  {{ blog.title }}
                </h6>
                <p class="fontsize-mini">{{ blog.summary.substr(0, blogSummaryLength) }} {{ blog.summary.length > blogSummaryLength ? '...' : '' }}</p>
              </div>
            </router-link> 
          </article>-->
        </div>
      </div>
      <div class="text-center">
        <MoreButton :to="'/weblog-list'" />
      </div>
    </div>
  </section>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min.js";

import HeaderSection from "@/parts/Front/components/HeaderSection";
import { BSkeleton, BSkeletonImg, BRow, BCol } from "bootstrap-vue";

import BigTitle from "@/parts/Front/nicecomponents/shared/BigTitle";
import MoreButton from "./shared/MoreButton.vue";
import postCard from "./postCard.vue";

export default {
  components: {
    HeaderSection,
    BSkeleton,
    BSkeletonImg,
    BRow,
    BCol,
    BigTitle,
    MoreButton,
    postCard,
  },
  name: "Weblogs",
  inject: ["mediaQueries"],

  // mounted() {
  //   // get height of articles/
  //   // let bodyWidth = document.body.offsetWidth;
  //   // const articleImg = document.querySelectorAll(".article-img");
  //   // if (bodyWidth < 767) {
  //   //   for (let iImg of articleImg) {
  //   //     let imgH = iImg.offsetWidth / 1.45;
  //   //     iImg.style.height = imgH + "px";
  //   //   }
  //   // }

  //   // window.addEventListener("resize", function () {
  //   //   // get height of articles/
  //   //   // let bodyWidth=document.body.offsetWidth;
  //   //   const articleImg = document.querySelectorAll(".article-img");
  //   //   for (let iImg of articleImg) {
  //   //     let imgH = iImg.offsetWidth / 1.45;
  //   //     iImg.style.height = imgH + "px";
  //   //   }
  //   // });
  // },

  computed: {
    showCount() {
      if (this.mediaQueries.xxxLarge) {
        return 10;
      }
      if (this.mediaQueries.xxLarge) {
        return 9;
      }

      return 9;
    },
    blogSummaryLength() {
      return window.innerWidth < 550 ? 70 : 130;
    },
    blogs() {
      //دریافت اطلاعات برای قسمت بلاگ که در تمپلیت بالا وارد آبجکت پست از این آبجکت میشود
      console.log(this.$store.getters["front/getHomeData"]);
      return this.$store.getters["front/getHomeData"];
    },
    status() {
      ///نمایش لودینگ ها به کمک استاتوس
      return this.$store.getters["front/getHomeDataStatus"];
    },
  },

  methods: {
    initPosts(kill = false) {
      this.initSwiper("Weblogs", kill, () => {
        new Swiper(".weblog-home .swiper-container", {
          spaceBetween: 30,

          loop: false,

          navigation: {
            nextEl: ".weblog-home  .swiper-button-next",
            prevEl: ".weblog-home  .swiper-button-prev",
          },

          breakpoints: {
            // 300: {
            //   slidesPerView: 2,
            //   spaceBetween: 10,
            // },
            // 500: {
            //   slidesPerView: 2,
            //   spaceBetween: 15,
            // },
            // 800: {
            //   slidesPerView: 3,
            //   spaceBetween: 15,
            // },
            // 992: {
            //   slidesPerView: 4,
            //   spaceBetween: 20,
            // },
            // 1280: {
            //   slidesPerView: 4,
            //   spaceBetween: 20,
            // },
            300: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            468: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 15,
            },

            1380: {
              slidesPerView: 4,
              spaceBetween: 15,
            },
            1550: {
              slidesPerView: 5,
              spaceBetween: 15,
            },
          },
        });
      });
    },
    // getEnough(array) {
    //   return [...array].splice(0, Math.min(array.length, this.showCount));
    // },
  },
  mounted() {
    this.initPosts();
    let bodyWidth = document.body.offsetWidth;
    const articleImg = document.querySelectorAll(".article-img");
    if (bodyWidth < 767) {
      for (let iImg of articleImg) {
        let imgH = iImg.offsetWidth / 1.45;
        iImg.style.height = imgH + "px";
      }
    }

    window.addEventListener("resize", function() {
      // get height of articles/
      // let bodyWidth=document.body.offsetWidth;
      // const articleImg = document.querySelectorAll(".article-img");
      // for (let iImg of articleImg) {
      //   let imgH = iImg.offsetWidth / 1.45;
      //   iImg.style.height = imgH + "px";
      // }
    });
  },
  watch: {
    blogs() {
      this.initPosts();
    },
  },
  // computed: {
  //   showCount() {
  //     if (this.mediaQueries.xxxLarge) {
  //       return 10;
  //     }
  //     if (this.mediaQueries.xxLarge) {
  //       return 9;
  //     }

  //     return 9;
  //   },
  //   categories() {

  //     if (this.$store.getters["front/getHomeData"] == null) {
  //       return null;
  //     } else {
  //       return this.getEnough(
  //         this.$store.getters["front/getHomeData"].special_categories
  //       );
  //     }
  //   },

  // },
};
</script>

<style scoped>
.weblog-home {
  margin-top: 70px;
}

.articles {
  /*background-color: white;*/
  padding: 1px 0 3.1rem 0;
}

.articles-content > article .article-img > img {
  transition: 300ms all;
}

.articles-content > article:hover .article-img > img {
  transform: scale(1.04);
}

.articles-content > article {
  background: white;
  padding: 3px;
}

.category {
  position: absolute;
  bottom: 0;
  right: 0;
  background: white;
  color: #000;
  padding: 3px 10px;
  z-index: 2;
}

.ml-05 {
  margin-left: 2px;
}

@media screen and (max-width: 600px) {
  .weblog-home {
    margin-top: 50px;
  }

  .articles {
    /*background-color: white;*/
    padding: 1px 0 0rem 0;
  }
}
</style>
